export const CollageLayoutsData = [
  {
    id: 1,
    name: "1x1 (Padding)",
    rows: 1,
    cols: 1,
    cells: [
      { x: 0.03, y: 0.03, width: 0.93, height: 0.93 },
    ],
  },
  {
    id: 2,
    name: "1x1 (Vertical Padding)",
    rows: 1,
    cols: 1,
    cells: [
      { x: 0.2, y: 0.05, width: 0.6, height: 0.9 },
    ],
  },
  {
    id: 3,
    name: "1x1 (Horizontal Padding)",
    rows: 1,
    cols: 1,
    cells: [
      { x: 0.05, y: 0.2, width: 0.9, height: 0.6 },
    ],
  },
  {
    id: 4,
    name: "1x1 (Square)",
    rows: 1,
    cols: 1,
    cells: [
      { x: 0.2, y: 0.1, width: 0.6, height: 0.8 },
    ],
  },
  {
    id: 5,
    name: "1x2 (Vertical)",
    rows: 1,
    cols: 1,
    cells: [
      { x: 0.52, y: 0.04, width: 0.46, height: 0.92 },
      { x: 0.02, y: 0.04, width: 0.46, height: 0.92 },
    ],
  },
  {
    id: 6,
    name: "2x1 (Horizontal)",
    rows: 1,
    cols: 1,
    cells: [
      { x: 0.04, y: 0.03, width: 0.92, height: 0.46 },
      { x: 0.04, y: 0.51, width: 0.92, height: 0.46 },
    ],
  },
  {
    id: 7,
    name: "2x2",
    rows: 2,
    cols: 2,
    cells: [
      { x: 0.02, y: 0.02, width: 0.46, height: 0.46 },
      { x: 0.52, y: 0.02, width: 0.46, height: 0.46 },
      { x: 0.02, y: 0.50, width: 0.46, height: 0.46 },
      { x: 0.52, y: 0.50, width: 0.46, height: 0.46 },
    ],
  },
  {
    id: 8,
    name: "Top 2 - Bottom 1",
    rows: 2,
    cols: 1,
    cells: [
      { x: 0.04, y: 0.03, width: 0.45, height: 0.46 },
      { x: 0.52, y: 0.03, width: 0.45, height: 0.46 },
      { x: 0.04, y: 0.53, width: 0.93, height: 0.44 },
    ],
  },
  {
    id: 9,
    name: "Top 1 - Bottom 2",
    rows: 2,
    cols: 1,
    cells: [
      { x: 0.04, y: 0.02, width: 0.93, height: 0.46 },
      { x: 0.04, y: 0.52, width: 0.45, height: 0.46 },
      { x: 0.52, y: 0.52, width: 0.45, height: 0.46 },
    ],
  },
  {
    id: 10,
    name: "Left 1 - Right 2",
    rows: 2,
    cols: 2,
    cells: [
      { x: 0.02, y: 0.04, width: 0.46, height: 0.92 },
      { x: 0.52, y: 0.04, width: 0.45, height: 0.44 },
      { x: 0.52, y: 0.50, width: 0.45, height: 0.44 },
    ],
  },
  {
    id: 11,
    name: "Left 2 - Right 1",
    rows: 2,
    cols: 2,
    cells: [
      { x: 0.02, y: 0.04, width: 0.46, height: 0.44 },
      { x: 0.52, y: 0.04, width: 0.46, height: 0.92 },
      { x: 0.02, y: 0.52, width: 0.46, height: 0.44 },
    ],
  },
  {
    id: 12,
    name: "2x2 Offset Grid",
    rows: 2,
    cols: 2,
    cells: [
      { x: 0.04, y: 0.04, width: 0.41, height: 0.51 },
      { x: 0.55, y: 0.04, width: 0.41, height: 0.41 },
      { x: 0.04, y: 0.60, width: 0.41, height: 0.36 },
      { x: 0.55, y: 0.50, width: 0.41, height: 0.46 },
    ],
  },
  {
    id: 13,
    name: "2x2 Split Balance",
    rows: 2,
    cols: 2,
    cells: [
      { x: 0.03, y: 0.04, width: 0.24, height: 0.46 },
      { x: 0.32, y: 0.04, width: 0.64, height: 0.46 },
      { x: 0.03, y: 0.58, width: 0.64, height: 0.38 },
      { x: 0.72, y: 0.58, width: 0.24, height: 0.38 },
    ],
  },
  {
    id: 14,
    name: "Left 1 - Right 3",
    rows: 3,
    cols: 2,
    cells: [
      { x: 0.04, y: 0.04, width: 0.34, height: 0.92 },
      { x: 0.42, y: 0.04, width: 0.54, height: 0.29 },
      { x: 0.42, y: 0.35, width: 0.54, height: 0.29 },
      { x: 0.42, y: 0.66, width: 0.54, height: 0.29 },
    ],
  },
  {
    id: 15,
    name: "Left 3 - Right 1",
    rows: 3,
    cols: 2,
    cells: [
      { x: 0.04, y: 0.04, width: 0.54, height: 0.29 },
      { x: 0.04, y: 0.35, width: 0.54, height: 0.29 },
      { x: 0.04, y: 0.66, width: 0.54, height: 0.29 },
      { x: 0.62, y: 0.04, width: 0.34, height: 0.92 },
    ],
  },
  {
    id: 16,
    name: "Top 1 - Bottom 3",
    rows: 2,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.92, height: 0.41 },
      { x: 0.04, y: 0.49, width: 0.27, height: 0.46 },
      { x: 0.37, y: 0.49, width: 0.27, height: 0.46 },
      { x: 0.69, y: 0.49, width: 0.27, height: 0.46 },
    ],
  },
  {
    id: 17,
    name: "Top 3 - Bottom 1",
    rows: 2,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.27, height: 0.41 },
      { x: 0.37, y: 0.04, width: 0.27, height: 0.41 },
      { x: 0.69, y: 0.04, width: 0.27, height: 0.41 },
      { x: 0.04, y: 0.49, width: 0.92, height: 0.46 },
    ],
  },
  {
    id: 18,
    name: "Left 2 - Right 3",
    rows: 3,
    cols: 2,
    cells: [
      { x: 0.04, y: 0.04, width: 0.34, height: 0.44 },
      { x: 0.04, y: 0.52, width: 0.34, height: 0.44 },
      { x: 0.42, y: 0.04, width: 0.54, height: 0.29 },
      { x: 0.42, y: 0.357, width: 0.54, height: 0.29 },
      { x: 0.42, y: 0.67, width: 0.54, height: 0.29 },
    ],
  },
  {
    id: 19,
    name: "Top 2 - Bottom 3",
    rows: 2,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.44, height: 0.34 },
      { x: 0.52, y: 0.04, width: 0.44, height: 0.34 },
      { x: 0.04, y: 0.42, width: 0.27, height: 0.54 },
      { x: 0.37, y: 0.42, width: 0.27, height: 0.54 },
      { x: 0.69, y: 0.42, width: 0.27, height: 0.54 },
    ],
  },
  {
    id: 20,
    name: "Left 3 - Right 2",
    rows: 3,
    cols: 2,
    cells: [
      { x: 0.04, y: 0.04, width: 0.41, height: 0.29 },
      { x: 0.04, y: 0.35, width: 0.41, height: 0.29 },
      { x: 0.04, y: 0.66, width: 0.41, height: 0.29 },
      { x: 0.55, y: 0.04, width: 0.41, height: 0.44 },
      { x: 0.55, y: 0.52, width: 0.41, height: 0.44 },
    ],
  },
  {
    id: 21,
    name: "Top 3 - Bottom 2",
    rows: 3,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.28, height: 0.41 },
      { x: 0.36, y: 0.04, width: 0.28, height: 0.41 },
      { x: 0.68, y: 0.04, width: 0.28, height: 0.41 },
      { x: 0.04, y: 0.49, width: 0.44, height: 0.46 },
      { x: 0.52, y: 0.49, width: 0.44, height: 0.46 },
    ],
  },
  {
    id: 22,
    name: "Staggered Mosaic",
    rows: 2,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.64, height: 0.34 },
      { x: 0.72, y: 0.04, width: 0.24, height: 0.62 },
      { x: 0.04, y: 0.42, width: 0.27, height: 0.54 },
      { x: 0.345, y: 0.42, width: 0.27, height: 0.23 },
      { x: 0.39, y: 0.72, width: 0.57, height: 0.24 },
    ],
  },
  {
    id: 23,
    name: "3x2",
    rows: 3,
    cols: 2,
    cells: [
      { x: 0.06, y: 0.08, width: 0.42, height: 0.24 },
      { x: 0.52, y: 0.08, width: 0.42, height: 0.24 },
      { x: 0.06, y: 0.36, width: 0.42, height: 0.24 },
      { x: 0.52, y: 0.36, width: 0.42, height: 0.24 },
      { x: 0.06, y: 0.64, width: 0.42, height: 0.24 },
      { x: 0.52, y: 0.64, width: 0.42, height: 0.24 },
    ],
  },
  {
    id: 24,
    name: "3x3",
    rows: 3,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.28, height: 0.28 },
      { x: 0.36, y: 0.04, width: 0.28, height: 0.28 },
      { x: 0.68, y: 0.04, width: 0.28, height: 0.28 },
      { x: 0.04, y: 0.36, width: 0.28, height: 0.28 },
      { x: 0.36, y: 0.36, width: 0.28, height: 0.28 },
      { x: 0.68, y: 0.36, width: 0.28, height: 0.28 },
      { x: 0.04, y: 0.68, width: 0.28, height: 0.28 },
      { x: 0.36, y: 0.68, width: 0.28, height: 0.28 },
      { x: 0.68, y: 0.68, width: 0.28, height: 0.28 },
    ],
  },
  {
    id: 25,
    name: "3x3",
    rows: 3,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.28, height: 0.28 },
      { x: 0.36, y: 0.04, width: 0.28, height: 0.28 },
      { x: 0.68, y: 0.04, width: 0.28, height: 0.28 },

      { x: 0.68, y: 0.36, width: 0.28, height: 0.28 },

      { x: 0.04, y: 0.35, width: 0.59, height: 0.61 },
      { x: 0.68, y: 0.68, width: 0.28, height: 0.28 },
    ],
  },
  {
    id: 26,
    name: "3x3",
    rows: 3,
    cols: 3,
    cells: [
      { x: 0.68, y: 0.04, width: 0.28, height: 0.28 },

      { x: 0.04, y: 0.04, width: 0.59, height: 0.60 },
      { x: 0.68, y: 0.36, width: 0.28, height: 0.28 },

      { x: 0.04, y: 0.68, width: 0.28, height: 0.28 },
      { x: 0.36, y: 0.68, width: 0.28, height: 0.28 },
      { x: 0.68, y: 0.68, width: 0.28, height: 0.28 },
    ],
  },
  {
    id: 27,
    name: "3x3",
    rows: 3,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.28, height: 0.28 },
      { x: 0.37, y: 0.04, width: 0.59, height: 0.60 },

      { x: 0.04, y: 0.36, width: 0.28, height: 0.28 },

      { x: 0.04, y: 0.68, width: 0.28, height: 0.28 },
      { x: 0.36, y: 0.68, width: 0.28, height: 0.28 },
      { x: 0.68, y: 0.68, width: 0.28, height: 0.28 },
    ],
  },
  {
    id: 28,
    name: "3x3",
    rows: 3,
    cols: 3,
    cells: [
      { x: 0.04, y: 0.04, width: 0.28, height: 0.28 },
      { x: 0.36, y: 0.04, width: 0.28, height: 0.28 },
      { x: 0.68, y: 0.04, width: 0.28, height: 0.28 },

      { x: 0.04, y: 0.36, width: 0.28, height: 0.28 },
      { x: 0.36, y: 0.36, width: 0.60, height: 0.60 },

      { x: 0.04, y: 0.68, width: 0.28, height: 0.28 },
    ],
  },
  {
    id: 29,
    name: "3x3",
    rows: 3,
    cols: 2,
    cells: [
      { x: 0.06, y: 0.08, width: 0.22, height: 0.24 },
      { x: 0.32, y: 0.08, width: 0.62, height: 0.24 },
      { x: 0.06, y: 0.36, width: 0.42, height: 0.24 },
      { x: 0.52, y: 0.36, width: 0.42, height: 0.24 },
      { x: 0.06, y: 0.64, width: 0.62, height: 0.24 },
      { x: 0.72, y: 0.64, width: 0.22, height: 0.24 },
    ],
  },
  {
    id: 30,
    name: "3x3",
    rows: 3,
    cols: 2,
    cells: [
    { x: 0.04, y: 0.04, width: 0.28, height: 0.6 },
    { x: 0.36, y: 0.04, width: 0.28, height: 0.28 },
    { x: 0.68, y: 0.04, width: 0.28, height: 0.28 },

    { x: 0.36, y: 0.36, width: 0.28, height: 0.28 },
    { x: 0.68, y: 0.36, width: 0.28, height: 0.60 },

    { x: 0.04, y: 0.68, width: 0.28, height: 0.28 },
    { x: 0.36, y: 0.68, width: 0.28, height: 0.28 },
    ],
  },
];